var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2752 17.753L18.7943 3.28269C18.6901 3.17822 18.5662 3.09533 18.4299 3.03878C18.2936 2.98223 18.1474 2.95312 17.9998 2.95312C17.8522 2.95312 17.7061 2.98223 17.5697 3.03878C17.4334 3.09533 17.3095 3.17822 17.2053 3.28269L2.72441 17.753C2.30254 18.1749 2.06348 18.7479 2.06348 19.3456C2.06348 20.5866 3.07246 21.5956 4.31348 21.5956H5.83926V31.921C5.83926 32.5432 6.34199 33.046 6.96426 33.046H15.7498V25.171H19.6873V33.046H29.0354C29.6576 33.046 30.1604 32.5432 30.1604 31.921V21.5956H31.6861C32.2838 21.5956 32.8568 21.36 33.2787 20.9346C34.1541 20.0557 34.1541 18.6319 33.2752 17.753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageIcon);
export default __webpack_public_path__ + "static/media/homepage-icon.0a6fdb26d8f7f0266b1cfac78cc70fb1.svg";
export { ForwardRef as ReactComponent };